import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hydrateComplete, loginSuccess } from '../store/authSlice';
import { clearAuthState, loadAuthState, saveAuthState } from '../utils/tokenStorage';

const useAuthPersistence = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);

  useEffect(() => {
    try {
      const stored = loadAuthState();
      if (stored?.user && stored?.tokens) {
        dispatch(loginSuccess(stored));
      } else {
        clearAuthState();
      }
    } catch (error) {
      console.error('Failed to restore auth session', error);
      clearAuthState();
    } finally {
      dispatch(hydrateComplete());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Do not erase the saved session while the restoration effect is hydrating it.
    if (!authState.hydrated) return;
    try {
      if (authState.user && authState.accessToken) {
        saveAuthState({
          user: authState.user,
          tokens: {
            accessToken: authState.accessToken,
            refreshToken: authState.refreshToken
          }
        });
      } else {
        clearAuthState();
      }
    } catch (error) {
      console.error('Failed to persist auth session', error);
      clearAuthState();
    }
  }, [authState.hydrated, authState.user, authState.accessToken, authState.refreshToken]);
};

export default useAuthPersistence;
